var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 88,
    viewBox: "0 0 100 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.5142 84.2227C87.1012 84.4679 86.681 84.6709 86.272 84.8398L87.687 84.1143C87.6293 84.1504 87.5724 84.188 87.5142 84.2227ZM98.1567 10.707C98.2058 11.403 98.196 12.113 98.1187 12.8242V12.8252L90.9585 78.9629V78.9639C90.6946 81.4228 89.3995 82.9881 87.8687 83.999L89.0024 82.5068C90.0709 81.0992 90.7466 79.3467 90.9478 77.4854L98.1079 11.3477V11.3467C98.131 11.1329 98.1466 10.9196 98.1567 10.707ZM3.47607 69.9482C3.8534 70.401 4.34125 70.8262 4.93311 71.0801C3.81707 70.7034 3.08747 69.9325 2.60498 68.9248L2.61572 68.915L3.47607 69.9482ZM7.40186 13.4922C7.28745 13.9606 7.20148 14.4387 7.14893 14.9189V14.9199L1.89209 63.4902C1.79545 64.3745 1.80864 65.2675 1.93213 66.1484L2.13721 67.6123C1.80921 66.3327 1.77358 64.9726 1.84033 63.9648L1.88037 63.501L7.13721 14.9287C7.19229 14.4214 7.28372 13.9431 7.40186 13.4922ZM40.5815 54.9365L40.561 54.9541L39.6558 53.6074L40.5815 54.9365ZM56.896 40.6357L55.896 41.5518L54.6792 42.6152L42.4429 53.3096L93.6694 6.9043L56.896 40.6357ZM9.73779 10.5879L9.26318 9.91602C9.26454 9.91443 9.26573 9.91271 9.26709 9.91113L9.73779 10.5879Z",
    fill: "white",
    stroke: "url(#paint0_linear_513_765)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_513_765",
    x1: 49.9997,
    y1: 0.9375,
    x2: 49.9997,
    y2: 87.0624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A86B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6661FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.e5198d7fd0118869e861071a10630f96.svg";
export { ForwardRef as ReactComponent };